class RecruitClick {
	constructor(el,opt){
    this.el = el;
    if($(this.el).length){
      this.event();
    }
	}
	event(){


    const btn = document.querySelector(".recruitBtn");
    const block = document.querySelector(".block");
    const remove = document.querySelector(".newrecruitBtn")

    btn.addEventListener("click",() => {
      block.classList.remove("is-hidden");
    })

    remove.addEventListener("click",() => {
      block.classList.add("is-hidden")
    })

	}
}
